import _ from 'lodash';

const uniqueStringsArr = (data, ele) => {
    const stringArr = data?.map(currentObj => {
        const filteredArray = currentObj?.workReportStatusArr?.filter(el => el !== "")
        if (filteredArray?.length > 1 && ele?.projectId == currentObj?.projectId && ele?.timeSummaryDate === currentObj?.date) {
            return "Partially Submitted"
        } else if (filteredArray?.length === 1 && ele?.projectId == currentObj?.projectId && ele.timeSummaryDate === currentObj.date) {
            return currentObj?.workReportStatusName
        }
    })
    const uniqueStrings = stringArr.filter((value, index, self) => {
        if (value) {
            return self.indexOf(value) === index;
        }
    });

    return uniqueStrings;
}



const customizedProjectsArr = (data) => {
    const FilteredUniqueNames = (data || [])?.map(item => [...new Set((item?.timeSheetReports || []).map(el => {
        return {
            projectId: el.projectId,
            date: el.timeSummaryDate,
            workReportStatusArr: [...new Set((item?.timeSheetReports || []).map(el => el?.workReportSummary?.projectSummaryList[0]?.workReportStatusName !== null ? el?.workReportSummary?.projectSummaryList[0]?.workReportStatusName : ""))],
            workReportStatusName: el?.workReportSummary?.projectSummaryList[0]?.workReportStatusName !== null ? el?.workReportSummary?.projectSummaryList[0]?.workReportStatusName : ""
        }
    }))]);

    const reducedArr = (FilteredUniqueNames || []).reduce((accumulator, item) => {
        return accumulator.concat(item)
    }, [])

    const uniqueArr = _.uniqWith(reducedArr, (a, b) => {
        return a.projectId === b.projectId && a.workReportStatusName === b.workReportStatusName && a.date === b.date;
    });

    const customizedArr = (data || [])?.map(ele => {
        return {
            ...ele,
            workReportStatusName: uniqueStringsArr(uniqueArr, ele)
        }
    })
    return customizedArr
}



export {
    customizedProjectsArr
}